import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { ScreenLoader } from "@/components/loaders";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useLazyGetUserPermissionsQuery } from "@/services/AuthService";
import { initializeRolePermissions } from "@/services/RolePermissionService";

const RequireAuth = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const location = useLocation();

  const token = useSelector((state: RootState) => state?.auth?.token);
  const loggedOutDueToError = useSelector(
    (state: RootState) => state?.auth?.loggedOutDueToError,
  );
  const userPermissions = useSelector(
    (state: RootState) => state?.auth?.userPermissions,
  );
  const [getUserPermissions] = useLazyGetUserPermissionsQuery();

  useEffect(() => {
    const loadPermissions = async () => {
      if (token && !userPermissions) {
        try {
          // If token exists but we don't have permissions yet, fetch them
          const permissionsResponse = await getUserPermissions({
            lang: "en",
          }).unwrap();

          if (permissionsResponse && permissionsResponse.length > 0) {
            // Initialize dynamic permissions
            initializeRolePermissions(permissionsResponse);
          }
        } catch (error) {
          console.error("Failed to fetch user permissions:", error);
        }
      }
      setIsLoading(false);
    };

    loadPermissions();
  }, [token, userPermissions, getUserPermissions]);

  if (isLoading) {
    return <ScreenLoader />;
  }

  return token ? (
    <Outlet />
  ) : (
    <Navigate
      to="/auth/login"
      state={loggedOutDueToError ? undefined : { from: location }}
      replace
    />
  );
};

export { RequireAuth };
